import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funktionsbereich-checklisten';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenFunktionsbereichChecklistenEffects {

    FunktionsbereichChecklisten$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKTIONSBEREICH_CHECKLISTEN),
        mergeMap((x: ac.GetFunktionsbereichChecklistenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunktionsbereichChecklisten(x.funktionsbereich_id).pipe(
                map((result: any) => {
                    return new ac.GetFunktionsbereichChecklistenErfolgreichAction(result, x.funktionsbereich_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunktionsbereichChecklistenFehlerAction(error, x.funktionsbereich_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenQueryService);
        }
        return this.service;
    }
}
